import React from 'react';

export default function Monitor() {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#a)'>
        <path
          d='m4.377 16.106 16 .011.007-11-16-.01zm8.999 2.006-.002 2 4 .003-.001 2-10-.007.001-2 4 .003.002-2-8.008-.005a.996.996 0 0 1-.992-1.008l.009-12.986c0-.556.456-1.007.993-1.006l18.016.012c.548 0 .991.45.991 1.007l-.009 12.986c0 .556-.455 1.007-.992 1.007z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='m.384.103 24 .015-.016 24-24-.015z' />
        </clipPath>
      </defs>
    </svg>
  );
}
